import React from 'react';
import { TextField, Checkbox, Autocomplete, AutocompleteInputChangeReason } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const useStyles = makeStyles()(theme => ({
  textField: {
    '& .MuiFormLabel-root.Mui-focused': {
      color: '#9F9F9F',
    },
  },
 
}));

const getObjectValue = obj => (obj ? (typeof obj.value === 'object' ? obj.id : obj.value) : obj);

const JobPreferencesAutoComplete = props => {
  const { defaultValue, options, label, onChange, id, disabled, multiSelect, value } = props;
  const [open, setOpen] = React.useState<boolean>(false);
  const { classes } = useStyles();
  const handleChange = (e, val, reason) => {
    onChange(e, val);
  };
  const getValues = () => {
    let values = [];
    if (multiSelect) {
      if (value) {
        if (Array.isArray(value)) {
          values = [...value];
        } else {
          values = [value];
        }
      } else {
        values = [];
      }
    } else {
      if (value) {
        values = value;
      } else {
        values = null;
      }
    }
    return values;
  };
  const onInputChange = (event, newInputValue: string, reason: AutocompleteInputChangeReason) => {
    if (props?.onInputChange) {
      props?.onInputChange(newInputValue);
    }
  };

  const renderMultiSelectOptions = (params, option, { selected }) => {
    if (multiSelect) {
      return (
        <li {...params} id={option.value}>
          <Checkbox
            size="small"
            icon={<CheckBoxOutlineBlankIcon color='secondary' />}
            style={{ marginRight: 8 }}
            checked={selected}
          />
          {option.name}
        </li>
      );
    } else {
      return (
        <li {...params}>
          <>{option.label ?? option.name}</>
        </li>
      );
    }
  };
  return (
    <div>
      <Autocomplete
        id={id}
        options={options}
        defaultValue={defaultValue}
        disableCloseOnSelect={multiSelect}
        popupIcon={open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        value={getValues()}
        limitTags={1}
        multiple={multiSelect}
        disabled={disabled}
        onClick={() => setOpen(true)}
        onInputChange={onInputChange}
        isOptionEqualToValue={(option, value) => getObjectValue(option) === getObjectValue(value)}
        renderTags={(option, getTagPrps) =>
          multiSelect ? (
            <span style={{ display: 'flex' }}>
              <p>{option[0]?.name}</p>
              {option?.length > 1 && <p style={{ marginLeft: '2px' }}>+{option?.length - 1}</p>}
            </span>
          ) : null
        }
        renderInput={params => <TextField {...params} className={classes.textField} variant="filled" label={label} />}
        getOptionLabel={option => option?.label ?? option.name}
        onChange={(e, val, reason) => {
          handleChange(e, val, reason);
          setOpen(false);
        }}
        renderOption={(params, option, { selected }) => renderMultiSelectOptions(params, option, { selected })}
        onClose={() => setOpen(false)}
      />
    </div>
  );
};

export default JobPreferencesAutoComplete;
